import { C, FONTS } from '../../tokens/design';

const DIR_MAP = {
  escalating: ['▲', C.red],
  stable:     ['—', C.t2],
  declining:  ['▼', C.grn],
};

export default function EpssVelocity({ direction, score }) {
  const [icon, color] = DIR_MAP[direction] || DIR_MAP.stable;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      fontSize: 12, color, fontFamily: FONTS.mono,
    }}>
      <b>{icon}</b>
      <span style={{ color: C.t2 }}>{Math.round(score * 100)}%</span>
    </span>
  );
}
